import React from 'react';
import PropTypes from 'prop-types';

import Title from '../../text/title/Title';
import Text from '../../text/paragraph/Text';

import { ImageWithCaptionStyled, ImageCaption } from './ImageWithCaption.styled';

const ImageWithCaption = ({ picture, titleCaption, textCaption }) => (
  <ImageWithCaptionStyled>
    <ImageCaption>
      <Title
        modifiers="micro"
        content={titleCaption}
      />
      <Text
        modifiers="small"
        content={textCaption}
      />
    </ImageCaption>
    <img src={picture} alt="Content" />
  </ImageWithCaptionStyled>
);

ImageWithCaption.propTypes = {
  picture: PropTypes.string,
  titleCaption: PropTypes.string,
  textCaption: PropTypes.string,
};

ImageWithCaption.defaultProps = {
  picture: '',
  titleCaption: '',
  textCaption: '',
};

export default ImageWithCaption;
